export const TITLES = {
  IDENTIFICATION: 'Identificação',
  COMERCIAL_CONDITIONS: 'Condições comerciais',
  ADDITIONAL_SERVICES: 'Serviços adicionais (obrigatórios e opcionais)',
  REFUNDS: 'Reembolsos',
}

export const MERCHANT_IDENTIFICATION = {
  designation: 'Oferta comercial',
  commercial_offer_modality: 'Modalidade da oferta comercial',
  description: 'Descrição da oferta comercial',
  market_segment_type: 'Segmento da oferta',
  commercial_offer_website: 'Endereço web da oferta comercial',
  website_standardized_contract_form:
    'Endereço web da ficha contratual padronizada',
  website_contract_conditions: 'Endereço web das condições gerais do contrato',
  contacts: 'Contacto comercial telefónico',
  email_contact: 'Contactos comercial eletrónico',
  website_contact: 'Contactos comercial eletrónico',
}

export const SUPPORT_OPTIONS = [
  {
    slug: 'w',
    text: 'Por escrito',
  },
  {
    slug: 'p',
    text: 'Presencial',
  },
  {
    slug: 't',
    text: 'Telefónico',
  },
  {
    slug: 'e',
    text: 'Eletrónico',
  },
]

export const BILLING_TYPE = {
  electronic_billing: 'Electrónica',
  paper_billing: 'Papel',
}

export const CONTRACT_TYPE = {
  email_contract_contact: 'Electrónica',
  location_contract_contact: 'Presencial',
  phone_contract_contact: 'Telefone',
}

export const PAYMENT_TYPE = {
  direct_debit: 'Débito direto em conta',
  atm_ctt: 'Multibanco / Transferência bancária',
  shop_payment: 'Loja / Agente autorizado',
}

export const ADDITIONAL_RESTRICTIONS = {
  partnerships: 'Obriga a parcerias com outras instituições',
  equipments: 'Destina-se a algum tipo de equipamento específico',
  consumers: 'Destina-se a um grupo de consumidores específico',
  consumptions: 'Obriga a consumos de energia mínimos/máximos',
}

export const COMERCIAL_CONDITIONS = {
  offer_type: 'Tipo de fornecimento',
  contract_duration: 'Duração do contrato (meses)',
  offer_start_date: 'Data de início da oferta comercial',
  offer_validity: 'Data de validade da oferta comercial',
  contract_type: 'Contratação',
  billing_type: 'Faturação',
  payment_type: 'Métodos de pagamento',
  direct_debit: 'Débito direto em conta',
  atm_ctt: 'Multibanco / Transferência bancária',
  shop_payment: 'Loja / Agente autorizado',
  support_options: 'Meios de atendimento',
  payment_periodicity: 'Modalidades na faturação',
  has_loyalty: 'Existe fidelização?',
  loyalty_clauses_description:
    'Descrição das cláusulas de fidelização, incluindo a penalização por rescisão antecipada',
  green_energy: 'Energia elétrica com origem 100% renovável',
  has_additional_restrictions: 'Restrições adicionais',
  additional_restrictions: 'Restrições adicionais',
  offer_restrictions:
    'Detalhe as restrições anteriores e/ou outras aplicáveis.',
  discount_as_uploaded:
    'Descrição de descontos/benefícios relevantes (exeto reembolsos)',
  price_function_of_access:
    'A tabela de preços é atualizada em função das tarifas de acesso às redes?',
  price_revision_conditions:
    'Outras políticas de atualização da tabela de preços',
  indexed_prices:
    'Preços indexados - existem mecanismos de revisão de preços inferiores a um ano?',
  indexed_prices_description: 'Descrição dos mecanismos de preços indexados',
}

export const ADDITIONAL_SERVICES = {
  required_subscription_additional_services:
    'Obrigatoriedade de contratação de serviços adicionais?',
  additional_services_cost:
    'Custo dos serviços adicionais obrigatórios (€/ano) sem IVA',
  additional_services_cost_with_vat:
    'Custo dos serviços adicionais obrigatórios (€/ano) após a aplicação da taxa de IVA aplicável',
  additional_services_description:
    'Descrição de todos os serviços adicionais obrigatórios',
  optional_services_description:
    'Descrição dos serviços adicionais opcionais relevantes',
}

export const REFUNDS_ENTRIES = {
  has_refunds: 'A oferta tem reembolsos?',
  annual_refunds: 'Reembolsos anuais',
  electricity_refund_fixed_term:
    'Eletricidade: reembolsos em % a aplicar no Termo Fixo',
  electricity_refund_energy_term:
    'Eletricidade: reembolsos em % a aplicar no Termo de Energia',
  electricity_refund_energy_function:
    'Eletricidade: reembolso em função da energia',
  gas_refund_fixed_term: 'Gás Natural: reembolsos em % a aplicar no Termo Fixo',
  gas_refund_energy_term:
    'Gás Natural: reembolsos em % a aplicar no Termo de Energia',
  gas_refund_energy_function: 'Gás Natural: reembolso em função da energia',
  refunds_description: 'Descrição de todos os reembolsos da oferta comercial',
}



// WEBPACK FOOTER //
// ./src/components/TariffDetails/information-entries.js